module.exports = __webpack_public_path__ + "public/SiteIcons/popular-left.png?3c78d50e";